module.exports = __webpack_public_path__ + "img/buddy_mouth-01.943602e1.svg";